import React, { useState, useEffect, Component } from "react";
import styled from "styled-components";

const UpArrow = require("../../../../assets/imgs/upArrow.png");
const DownArrow = require("../../../../assets/imgs/downArrow.png");

let sendData = [];

const ComputeEMI = (props) => {
  const buttonStyleEnabled = { background: "#003E8D", pointerEvents: "auto" };
  const buttonStyleDisabled = { background: "#a8aad3", pointerEvents: "none" };

  const [buttonStyle, setButtonStyle] = useState(buttonStyleEnabled);

  const { SnpComputeEMI } = props;

  useEffect(() => {

    if (props.logoutUser == false || props.logoutUser == undefined) {
      disableButtons(true);
    } else {
      disableButtons(false);
    }
  }, [props.logoutUser]);

  const disableButtons = (isDisabled) => {
    if (isDisabled) {
      setButtonStyle(buttonStyleDisabled);
    } else {
      setButtonStyle(buttonStyleEnabled);
    }
  };

  const handleProceed = () => {

    if (sendData.length == SnpComputeEMI.length) {
      document.getElementById("computeEMIoptions").style.pointerEvents = "none";
      let inputString = "Proceed" + "<split>" + JSON.stringify(sendData);
      window["autosubmit"](inputString);
      setButtonStyle(buttonStyleDisabled);
      sendData = [];
    } else if (SnpComputeEMI.length == 1) {
      props.overlayMessageToggle("Please select tenure");
    } else {
      props.overlayMessageToggle(
        "Please select tenure for the other transaction"
      );
    }

  };

  //css
  const ButtonProceed = styled.div`
    width: 100%;
    margin-top: 10px;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    line-height: 36px;
    cursor: pointer;
    display: inline-block;
    pointer-events: ${buttonStyle.pointerEvents};
    background: ${buttonStyle.background};
  `;
  //
  const showComputeEMI = (val) => {
    return (
      <div id="computeEMIoptions">
        {SnpComputeEMI.map((item, i) => {
          return (
            <React.Fragment key={i}>
              <EMIAccordion
                transactionEMItitle={item.narrative}
                transactionEMIamount={item.amount.replace(
                  /(\d)(?=(\d\d)+\d$)/g,
                  "$1,"
                )}
                EMITenurePlans={item.PLAN_DATA}
                transactionNum={item.transactionNo}
                showEMIdetail={buttonStyle==buttonStyleEnabled?i==0?true:false:false}

              />
            </React.Fragment>
          );
        })}
      </div>
    );
  };
  return (
    <React.Fragment>
      {showComputeEMI()}
      <ButtonProceed id="ConvertToEMI" onClick={() => handleProceed()}>
        Proceed
      </ButtonProceed>
    </React.Fragment>
  );
};

//EMIAccordion Component
class EMIAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundImage: this.props.showEMIdetail?UpArrow:DownArrow,
      isClicked: this.props.showEMIdetail?true:false,
      showEMIdetail: false,

    };
    this.userSelected = {
      PLAN_DATA: {},
      transactionNo: 0,
      // amount: " ",
      // narrative: " "
    };

    this.showEMIdetail2 = this.props.showEMIdetail;

  }

  componentWillReceiveProps() {
    this.showEMIdetail2 = this.props.showEMIdetail;
  }

  handleClickState = () => {
    if (this.state.isClicked == false) {
      this.setState({
        isClicked: true,
        backgroundImage: UpArrow,
        showEMIdetail: true,
      });
      this.showEMIdetail2 = true;
    } else {
      this.setState({
        isClicked: false,
        backgroundImage: DownArrow,
        showEMIdetail: false,
      });
      this.showEMIdetail2 = false;
    }
  };

  handleRadioChange = (
    selectedEMIPlan,
    transactionNum,
    transactionEMIamount,
    transactionEMItitle
  ) => {
 
    this.userSelected.transactionNo = transactionNum;
    // this.userSelected.amount = transactionEMIamount;
    // this.userSelected.narrative = transactionEMItitle;
    this.userSelected.PLAN_DATA = selectedEMIPlan;

    if (sendData.length != 0) {
      if (
        sendData.filter((data) => data.transactionNo === transactionNum)
          .length == 0
      ) {
        sendData.push(this.userSelected);
      }
    } else {
      sendData.push(this.userSelected);
      
    }
    //window.document.getElementById("EMIplanResponse").style.pointerEvents="none"; //not working
  };

  render() {
    const ComputeEMI_mainBlock = styled.div`
      position: relative;
      display: flex;
      flex-direction: column;
      margin: 12px 4px 0px 4px;
      border: 1px solid #fcfcfc;
      border-radius: 4px;
      box-shadow: 0px 5px 12px rgba(0, 0, 0, 0.2);
      background: #fcfcfc;
    `;
    const EMI_titleBlock = styled.div`
      cursor: pointer;

      & .transactionTitle {
        font-size: 14px;
        color: #282828;
        font-weight: 500;
        padding: 16px;
        width: 220px;
      }

      & .arrowBlock {
        position: absolute;
        top: 16px;
        right: 0px;
        height: 30px;
        width: 30px;
        background: url(${this.state.backgroundImage});
        background-repeat: no-repeat;
      }
    `;
    const EMI_detailBlock = styled.div`
      & .computeEMI_amount {
        padding: 0 16px 16px 16px;
        font-size: 14px;
      }

      & .EMI_tenure {
      }

      & .sf-radioSelect {
        font-size: 14px;
        padding: 10px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        margin-left: 8px;
        margin-bottom: 8px;
        width: 45.5%;
        display: inline-block;
        color: #003e8d;
        font-weight: 500;
     

        input[type=radio]+label {
          height: 0px;
          width: 100%;
          display: inline-block;
          margin: 0px 0px 0 0;
          position: relative;
          padding: 0;
          background: none;
          background-size: none;
          top: 0px;
          color: #003e8d;

        }

        input[type=radio] {

          display: inline-block;
       
        


       }
    `;
    //
    return (
      <ComputeEMI_mainBlock>
        <EMI_titleBlock onClick={() => this.handleClickState()}>
          <div className="transactionTitle">
            {this.props.transactionEMItitle}
          </div>
          <div className="arrowBlock" />
        </EMI_titleBlock>

        {this.showEMIdetail2 ? (
          <EMI_detailBlock>
            {/* <div className = "computeEMI_transcation">
                        Transaction Details <br></br>
                        <div>
                            Upwork - 300405514 Ref Dublin IRL
                        </div>
                    </div> */}
            <div className="computeEMI_amount">
              Choose EMI tenure for <br />
              <div
                style={{
                  color: "#003E8D",
                  fontSize: "17px",
                  fontWeight: "500",
                }}
              >
                ₹ {this.props.transactionEMIamount}
              </div>
            </div>
            <div className="EMI_tenure" id="EMIplanResponse">
              {this.props.EMITenurePlans.map((item, i) => {
                return (
                  <div
                    className="sf-radioSelect"
                    key={i}
                    onChange={() =>
                      this.handleRadioChange(
                        item,
                        this.props.transactionNum,
                        this.props.transactionEMIamount,
                        this.props.transactionEMItitle
                      )
                    }
                  >
                    <input
                      type="radio"
                      style={{ cursor: "pointer", width: "auto"}}
                      name={this.props.transactionNum}
                    />
                    <label>
                      {item.PLAN_DESC}
                      <div
                        style={{
                          // textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "300",
                          color: "#666666",
                        }}
                      >
                        EMI Amount: ₹{item.EMI_AMT}
                      </div>
                    </label>
                  </div>
                );
              })}
            </div>
          </EMI_detailBlock>
        ) : null}
      </ComputeEMI_mainBlock>
    );
  }
}

// EMI summary Component
const SelectedEMIDetail = (props) => {
  const buttonStyleEnabled = { background: "#003E8D", pointerEvents: "auto" };
  const buttonStyleDisabled = { background: "#a8aad3", pointerEvents: "none" };
  const buttonStyleSecondaryEnabled = {
    background: "#003E8D",
    pointerEvents: "auto",
  };
  const buttonStyleSecondaryDisabled = {
    background: "#a8aad3",
    pointerEvents: "none",
  };

  const [buttonStyle, setButtonStyle] = useState(buttonStyleDisabled);
  const [buttonStyleSecondary, setButtonStyleSecondary] = useState(
    buttonStyleSecondaryEnabled
  );
  const [checked, setChecked] = useState(false);

  const { EPP_PlansResponse } = props;
  // const EPP_PlansResponse = something;//For testing -> remove this

  useEffect(() => {

    if (props.logoutUser == false || props.logoutUser == undefined) {
      // setButtonStyle(buttonStyleDisabled);
      disableButtons(true);
    } else {
      disableButtons(false);
    }
  }, [props.logoutUser]);

  const disableButtons = (isDisabled) => {
    if (isDisabled) {
      // setButtonStyle(buttonStyleDisabled);
      let i,
        proceedButton = document.getElementsByClassName("buttonProceed");

      for (i = 0; i < proceedButton.length; i++) {
        proceedButton[i].classList.add("disabledButtonProceed");
        if (i == proceedButton.length - 1) {
          if (
            proceedButton[i].nextElementSibling.style.pointerEvents == "none"
          ) {
            proceedButton[i].classList.add("disabledButtonProceed");
          }
        }
      }

      setButtonStyleSecondary(buttonStyleSecondaryDisabled);
    } else {
      // setButtonStyle(buttonStyleDisabled);
      setButtonStyleSecondary(buttonStyleSecondaryEnabled);
    }
  };

  const handleProceed = (event) => {
    let item = event.target.parentElement;
    let checkbox = item.querySelector("#terms-and-conditions");

    let inputString = "Continue" + "<split>" + "Continue";
    if (checkbox && checkbox.checked) {
      window["autosubmit"](inputString);
      event.target.classList.add("disabledButtonProceed");
      setButtonStyleSecondary(buttonStyleSecondaryDisabled);
    } else {
      props.overlayMessageToggle(
        "Please read carefully and agree to the Terms and Conditions"
      );
    }
  };

  const handleOther = () => {
    let inputString = "Explore Other Plans" + "<split>" + "Explore Other Plans";
    window["autosubmit"](inputString);
    setButtonStyleSecondary(buttonStyleSecondaryDisabled);
    setButtonStyle(buttonStyleDisabled);
  };

  const handleCheck = (ev) => {
    setChecked(!checked);
    if (ev.target.checked) {
      ev.target.parentElement.nextElementSibling.classList.remove(
        "disabledButtonProceed"
      );
    } else {
      ev.target.parentElement.nextElementSibling.classList.add(
        "disabledButtonProceed"
      );
    }
  };

  //CSS

  const ButtonCancel = styled.div`
    width: 95%;
    border: 1px solid ${buttonStyleSecondary.background};
    border-radius: 4px;
    color: ${buttonStyleSecondary.background};
    text-align: center;
    line-height: 36px;
    cursor: pointer;
    margin: 10px auto;
    pointer-events: ${buttonStyleSecondary.pointerEvents};
  `;
  // const ButtonProceed = styled.div`
  //   width: 95%;
  //   // background: #003E8D;
  //   border-radius: 4px;
  //   color: #fff;
  //   text-align: center;
  //   line-height: 36px;
  //   cursor: pointer;
  //   margin: 10px auto;
  //   pointer-events: ${buttonStyle.pointerEvents};
  //   background: ${buttonStyle.background};
  // `;
  const CheckTC = styled.div`
    display: flex;
    justify-content: space-evenly;
  `;

  //

  const showSelectedEMIDetail = () => {
    let totalEMIAmount = 0;
    let totalFee = 0;

    EPP_PlansResponse.forEach((item) => {
      totalEMIAmount += parseFloat(item.EMI_AMT);
      totalFee += parseFloat(item.CONV_FEE);
    });
 
    // setButtonStyle(buttonStyleDisabled);
    return (
      <div>
        <EMIplanSummary>
          <PlanTitle>SUMMARY</PlanTitle>
          <PlanRow>
            <PlanLabel>Total EMI*</PlanLabel>
            <PlanValue>₹ {totalEMIAmount.toFixed(2)}</PlanValue>
          </PlanRow>
          <PlanRow>
            <PlanLabel>Processing fee*</PlanLabel>
            <PlanValue>₹ {totalFee}</PlanValue>
          </PlanRow>
        </EMIplanSummary>

        {EPP_PlansResponse.map((item, i) => {
          return (
            <StatementDetail key={i}>
              <SummaryAccordion
                TransactionEMItitle={item.narrative}
                TransactionAmount={item.PRIN_AMT.replace(
                  /(\d)(?=(\d\d)+\d$)/g,
                  "$1,"
                )}
                EMIAmount={item.EMI_AMT.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,")}
                InterestRate={item.INT_RATE}
                ProcessingFee={item.CONV_FEE.replace(
                  /(\d)(?=(\d\d)+\d$)/g,
                  "$1,"
                )}
                EMITrem={item.TERM}
              />
            </StatementDetail>
          );
        })}
      </div>
    );
  };
  return (
    <React.Fragment>
      {showSelectedEMIDetail()}

      <div
        style={{
          fontSize: "12px",
          width: "95%",
          textAlign: "right",
          color: "#919191",
          marginTop: "12px",
        }}
      >
        *Taxes Applicable
      </div>

      <CheckTC>
        <input
          checked={checked}
          type="checkbox"
          id="terms-and-conditions"
          onChange={(ev) => handleCheck(ev)}
        />
        <span>
          I agree to the{" "}
          <a
            target="_blank"
            href="https://webassets.rbl.bank.in/pdfs/CreditCard/Terms_Conditions_splitnpay.pdf"
            style={{ cursor: "pointer" }}
          >
            Terms and Conditions
          </a>
        </span>
      </CheckTC>

      <div className="buttonProceed disabledButtonProceed" onClick={() => handleProceed(event)}>
        Proceed
      </div>
      <ButtonCancel onClick={() => handleOther()}>
        Explore Other Plans
      </ButtonCancel>
    </React.Fragment>
  );
};

const StatementDetail = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;

  // & .zeroMargin{
  // padding-right:0px;
  // width:100%;
  // }
`;

const EMIplanSummary = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  background: radial-gradient(
    circle at 100% 130%,
    rgba(0, 62, 141, 0.7),
    rgba(0, 62, 141, 0.9)
  );
  //background: radial-gradient(circle at 100% 130%, rgba(89,102,170,1), rgba(68,80,114,1));
  //background-image: linear-gradient(297deg, #5966aa, #445090 6%);
  color: white;
  font-size: 14px;
  // min-width:280px;
  padding-bottom: 14px;
  margin: 12px 12px 0 12px;
`;
const PlanTitle = styled.div`
  padding: 14px;
  border-bottom: 1px dashed #fff;
`;
const PlanRow = styled.div`
  padding-top: 14px;
  padding-left: 14px;
`;

const PlanLabel = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 40%;
  text-align: left;
`;
const PlanValue = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 60%;
  text-align: right;
  font-weight: 600;
  padding-right: 14px;
`;
//EMIAccordion Component
class SummaryAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundImage: DownArrow,
      isClicked: false,
      showSummaryDetail: false,
    };
  }

  handleClickState = () => {
    if (this.state.isClicked == false) {
      this.setState({
        isClicked: true,
        backgroundImage: UpArrow,
        showSummaryDetail: true,
      });
    } else {
      this.setState({
        isClicked: false,
        backgroundImage: DownArrow,
        showSummaryDetail: false,
      });
    }
  };

  render() {
    const Summary_mainBlock = styled.div`
      position: relative;
      display: flex;
      flex-direction: column;
      margin: 0px 12px;
      border: 1px solid #fcfcfc;
      border-radius: 4px;
      box-shadow: 0px 5px 12px rgba(0, 0, 0, 0.2);
      background: #fcfcfc;
    `;
    const Summary_titleBlock = styled.div`
      cursor: pointer;

      & .transactionTitle {
        font-size: 14px;
        font-weight: 500;
        padding: 12px;
        width: 220px;
      }

      & .arrowBlock {
        position: absolute;
        top: 16px;
        right: 0px;
        height: 30px;
        width: 30px;
        background: url(${this.state.backgroundImage});
        background-repeat: no-repeat;
      }
    `;
    const Summary_detailBlock = styled.div``;

    const DashDivider = styled.div`
      border-bottom: 1px dashed rgba(102, 102, 102, 0.2);
    `;
    const PlanRow = styled.div`
      padding: 10px 12px;
    `;
    const PlanLabel = styled.div`
      display: inline-block;
      vertical-align: middle;
      width: 60%;
      text-align: left;
      margin: 0px;
    `;
    const PlanValue = styled.div`
      display: inline-block;
      vertical-align: middle;
      width: 40%;
      text-align: right;
      font-weight: 600;
    `;
    //
    return (
      <Summary_mainBlock>
        <Summary_titleBlock onClick={() => this.handleClickState()}>
          <div className="transactionTitle">
            {this.props.TransactionEMItitle}
          </div>
          <div className="arrowBlock" />
        </Summary_titleBlock>

        {this.state.showSummaryDetail ? (
          <Summary_detailBlock>
            <DashDivider />
            <PlanRow>
              <PlanLabel>Amount</PlanLabel>
              <PlanValue>₹{this.props.TransactionAmount}</PlanValue>
            </PlanRow>
            <DashDivider />
            <PlanRow>
              <PlanLabel>EMI*</PlanLabel>
              <PlanValue>₹{this.props.EMIAmount}</PlanValue>
            </PlanRow>
            <DashDivider />
            <PlanRow>
              <PlanLabel>Rate of Interest*</PlanLabel>
              <PlanValue>{this.props.InterestRate}%</PlanValue>
            </PlanRow>
            <DashDivider />
            <PlanRow>
              <PlanLabel>Term</PlanLabel>
              <PlanValue>{this.props.EMITrem} Months</PlanValue>
            </PlanRow>
            <DashDivider />
            <PlanRow>
              <PlanLabel>Processing fee*</PlanLabel>
              <PlanValue>₹{this.props.ProcessingFee}</PlanValue>
            </PlanRow>
          </Summary_detailBlock>
        ) : null}
      </Summary_mainBlock>
    );
  }
}

export { SelectedEMIDetail };

export default ComputeEMI;
